import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { UserPublicInterface } from '../interfaces/user-public.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import {
  IsBoolean,
  IsEmail,
  IsString,
  IsUUID,
  MaxLength,
  MinLength,
} from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { Transform } from 'class-transformer';
import { UserRoleDto } from '../../user-role/dto/user-role.dto';
import { UserRegionDto } from '../../user-region/dto/user-region.dto';
import { ContractorDto } from '../../contractor/dto/contractor.dto';
import { ContractorInterface } from '../../contractor/interfaces/contractor.interface';

@Exclude()
export class UserDto extends CommonEntityDto implements UserPublicInterface {
  @ApiProperty({
    description: 'Identifier manually carried over from external system.',
  })
  @IsString()
  @MinLength(1)
  @MaxLength(100)
  @Expose()
  idNumber!: string;

  @ApiProperty({
    description:
      'This will be automatically overwritten with the value which is set for e-mail.',
  })
  @IsString()
  @MinLength(4)
  @MaxLength(100)
  @Expose()
  username!: string;

  @ApiProperty()
  @IsString()
  @MinLength(1)
  @MaxLength(50)
  @Expose()
  firstName!: string;

  @ApiProperty()
  @IsString()
  @MinLength(1)
  @MaxLength(50)
  @Expose()
  lastName!: string;

  @ApiProperty()
  @IsEmail()
  @MinLength(1)
  @MaxLength(100)
  @Expose()
  email!: string;

  @ApiProperty()
  @MinLength(1)
  @MaxLength(100)
  @Expose()
  primaryPhone!: string;

  @ApiProperty()
  @IsBoolean()
  @Expose()
  active!: boolean;

  @ApiProperty({ type: () => [UserRoleDto], required: false })
  @Expose()
  userRoles!: UserRoleDto[];

  @ApiProperty({ type: () => [UserRegionDto], required: false })
  @Expose()
  userRegions!: UserRegionDto[];

  @ApiProperty({
    description: 'Contractor Id',
  })
  @IsUUID()
  @Expose()
  contractorId!: string;

  @ApiPropertyOptional({
    type: ContractorDto,
    title: 'Associated Contractor',
    description: 'Contractor associated with this user',
  })
  @Expose()
  contractor?: ContractorInterface;

  @ApiProperty({
    description: 'Show TN Report',
    type: Boolean,
  })
  @Expose()
  showTNReports!: boolean;
}
